module.exports = __webpack_public_path__ + "static/photo_7-59d19d4348b76e364de8aa7c0588715d.jpg";